import { parseURI } from '@cian/http-api';
import { fetchHostByLocation } from '../../services/fetchHostByLocation';
import { TThunkAction } from '../../types/redux';
import { smoothScrollToPositionAsync } from '../../utils/scroll';
import { startFetching } from '../buildersProjects';

export const changeLocation = (regionId: number): TThunkAction => {
  return async (dispatch, _, context) => {
    dispatch(startFetching());

    const [newHost] = await Promise.all([
      fetchHostByLocation(context, { currentLocationId: regionId }),
      smoothScrollToPositionAsync(0),
    ]);

    const url = parseURI(window.location.href);
    const queryParams = new URLSearchParams(url.query);

    if (queryParams.has('page')) {
      queryParams.delete('page');
    }

    const queryString = queryParams.size ? `?${queryParams}` : '';

    window.location.href = [newHost, url.path, queryString].join('');
  };
};
